import AuthWrapper from './AuthWrapper';
import './axiosInterceptors';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SovosProvider } from 'mosaic-react';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';

const queryClient = new QueryClient();
const DevOTPWrapper = React.lazy(() => import('./dev/DevOTPWrapper'));

const AppWrapper: React.FC = () => (
	<BrowserRouter>
		<SovosProvider>
			<QueryClientProvider client={queryClient}>
				{process.env.NODE_ENV === 'development' ? (
					<DevOTPWrapper>
						<AuthWrapper />
					</DevOTPWrapper>
				) : (
					<AuthWrapper />
				)}
			</QueryClientProvider>
		</SovosProvider>
	</BrowserRouter>
);

export default AppWrapper;
